import React, {Component} from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import {getCoords} from '../../../../helpers/common'


class Answers extends Component {
    state = {
        needMaxHeight : false,
    }
    render() {
        const {answers, handleAnswerBlur, handleAnswerChange, handleAnswerCancelClick, handleAnswerOkClick, className = ""} = this.props
        const {needMaxHeight} = this.state
        const {Answer} = this
        Answer.displayName = 'Answer'
        return (
            <div
                className={cn(className, "answers-block")}
                ref = {this.getRef}
                style = {needMaxHeight ? {maxHeight: Answers.MAX_HEIGHT} : {}}
            >
                {
                    answers.map(({text, label, isCorrect, storeKey, procent}, index) => {
                        return <Answer
                            key = {storeKey}
                            isLast = {answers.length - 1 === index}
                            text = {text}
                            answerLabel = {label}
                            procent = {procent}
                            isCorrect = {isCorrect}
                            onBlur = {handleAnswerBlur}
                            onChange = {handleAnswerChange(storeKey)}
                            handleCancel = {handleAnswerCancelClick(storeKey)}
                            handleOk = {handleAnswerOkClick(storeKey)}
                        />
                    })
                }
            </div>
        )
    }

    static MAX_HEIGHT = 195

    componentDidMount() {
        this.handleMaxHeight()
    }

    componentDidUpdate() {
        const {lastAnswerFocused} = this.props
        if (lastAnswerFocused && this.lastAnswerRef) this.lastAnswerRef.focus()
        this.handleMaxHeight()
    }

    handleMaxHeight = () => {
        let {isPopover} = this.props
        if (isPopover && this.answersRef) {
            let {top : topToDocument} = getCoords(this.answersRef)
            if (this.topToDocument !== topToDocument) {
                this.topToDocument = topToDocument
            }
            if (this.topToDocument <= Answers.MAX_HEIGHT && !this.state.needMaxHeight) {
                this.setState({needMaxHeight : true})
            }
        }
    }

    getRef = ref => this.answersRef = ref

    Answer = ({text, procent, isCorrect, answerLabel, isLast, onBlur, onChange, handleCancel, handleOk}) => (text &&
        <div className={cn({"answer-component" : 1, "right" : isCorrect})}>
            <div className="procent">{procent ? procent.toFixed(2) : 0.00}%</div>
            <div className="answer-label">{answerLabel}</div>
            <textarea
                {...(isLast ? {ref : this.getLastAnswerRef} : {})}
                onBlur = {onBlur}
                onChange = {onChange}
                value = {text}
                className={cn("answer-content", {"answer-content--read-only" : this.props.viewMode,})}
                readOnly={this.props.viewMode}
            ></textarea>
            {
                !this.props.viewMode
                &&
                <React.Fragment>
                    <span onClick={handleCancel} className="cross-icon"></span>
                    <span onClick={handleOk} className="checked-icon"></span>
                </React.Fragment>
            }
        </div> || null
    )

    getLastAnswerRef = ref => this.lastAnswerRef = ref

    static proptypes = {
        viewMode : PropTypes.bool,
        answers : PropTypes.array.isRequired,
        handleAnswerBlur : PropTypes.func.isRequired,
        handleAnswerChange : PropTypes.func.isRequired,
        handleAnswerCancelClick : PropTypes.func.isRequired,
        handleAnswerOkClick : PropTypes.func.isRequired,
        lastAnswerFocused : PropTypes.bool.isRequired,
        className : PropTypes.string,
    }

    static defaultProps = {
        readOnly : false,
        answers : [],
        handleAnswerBlur : ()=>{},
        handleAnswerChange : ()=>{},
        handleAnswerCancelClick : ()=>{},
        handleAnswerOkClick : ()=>{},
        lastAnswerFocused : false,
        className : "",
    }
}

export default Answers


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/QbmPage/QbmBody/QuestionForm/Answers.js